import { TaskWithSub } from 'entities';

import { Collapse, Column } from 'components/Blocks';
import { UserAvatar } from 'components/UserAvatar';
import { EntityStatusTag } from 'components/Entities';

interface SubTasksProps {
  show: boolean;
  subTasks: TaskWithSub['subTasks'];
}

export function SubTasks({ show, subTasks }: SubTasksProps) {
  return (
    <Collapse expanded={show} onlyRenderIfExpanded>
      <Column gap="2" className="px-6 phone:px-3 small_phone:px-1">
        {subTasks.map((subTask) => (
          <div key={subTask.id} className="grid grid-cols-3 gap-2 rounded-lg bg-muted/60 p-2">
            <span className="phone:col-span-2">{subTask.name}</span>

            <UserAvatar size={32} user={subTask.owner} name className="text-sm phone:col-span-2" />

            <EntityStatusTag
              target="subTask"
              status={subTask.status}
              className="w-full max-w-28 justify-self-end phone:col-start-3 phone:row-start-1 phone:w-fit phone:text-sm"
            />
          </div>
        ))}
      </Column>
    </Collapse>
  );
}
